import React, { useContext, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { UserContext } from '../App'
import firebase from 'firebase'
import hamburger from '../images/menu.svg'

function NavBar({ isInNoUserPage }) {
    const [img, setImg] = useState('')
    const CurrentUser = useContext(UserContext) || 'nouser'
    useEffect(
        () => {
            let isSubs = true
            if (!isInNoUserPage) {
                firebase.database().ref().get()
                    .then(s => {
                        if (s.child('users').child(CurrentUser.uid).exists()) {
                            if (isSubs) {
                                setImg(s.child('users').child(CurrentUser.uid).child('linkid').val())
                            }
                        }
                    })
            }
            return () => isSubs = false
        }
    )
    return (
        <div className="">
            <nav className="navbar navbar-expand-lg sticky-top ">
                <div className="navbar-brand text-primary " >Link Showcase</div>
                <div className=' ml-auto'>
                    <button className="dropdown navbar-toggler "
                        type="button" data-toggle="collapse"
                        data-target="#navbarSupportedContent"
                        aria-controls="navbarSupportedContent"
                        aria-expanded="true" aria-label="Toggle navigation">
                        <span>
                            <svg viewBox="0 0 100 80" width="20" height="30">
                                <rect fill='#add7ff' stroke='#add7ff' width="100" height="10"></rect>
                                <rect fill='#add7ff' stroke='#add7ff' y="30" width="100" height="10"></rect>
                                <rect fill='#add7ff' stroke='#add7ff' y="60" width="100" height="10"></rect>
                            </svg>
                        </span>
                    </button>
                    <div className="collapse navbar-collapse " id="navbarSupportedContent">
                        <ul className="p-2 navbar-nav mr-auto">
                            <li className="nav-item">
                                <Link to='/' className="nav-link" >Home</Link>
                            </li>
                            <li className="nav-item ">
                                {isInNoUserPage === null || CurrentUser === 'nouser' ?
                                    <Link to='/signin' className='nav-link '>SignIn</Link>
                                    :
                                    <Link to='/user' className='nav-link p-2  ml-1'>
                                        <img style={{ height: '35px', borderRadius: '35px' }}
                                            src={CurrentUser.photoURL || ''}></img>
                                    </Link>
                                }
                            </li>
                        </ul>
                    </div>
                </div>

            </nav>
        </div >
    )
}

export default NavBar
